/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpRespTitle_item = {
    readonly title: string | null;
    readonly isArt: boolean | null;
    readonly vertical: VerticalType | null;
    readonly creators: ReadonlyArray<{
        readonly creator: {
            readonly name: string | null;
            readonly displayName: string | null;
        } | null;
    } | null> | null;
    readonly classification: {
        readonly creationDate: string | null;
    } | null;
    readonly " $refType": "PdpRespTitle_item";
};
export type PdpRespTitle_item$data = PdpRespTitle_item;
export type PdpRespTitle_item$key = {
    readonly " $data"?: PdpRespTitle_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespTitle_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespTitle_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isArt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vertical",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creators",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemCreator",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "creator",
          "storageKey": null,
          "args": null,
          "concreteType": "Creator",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displayName",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "classification",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemClassification",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "creationDate",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'b72b500e6b5adb633e7e2b0e6c0924f3';
export default node;
